import OtherPrayerCard from './CardPrayerOther';

export default OtherPrayerCard;
